export * from './storage-classes';
export * from './volumes';
export * from './snapshots';

// Re-export commonly used items
export { mockStorageClasses, getStorageClassById, getStorageClassByTier, getDefaultStorageClass } from './storage-classes';
export { mockVolumes, mockVolumeActivityLogs, generateMetricsHistory, getVolumeById, getActivityLogsForVolume } from './volumes';
export { mockSnapshots, mockSchedules, getSnapshotsForVolume, getSchedulesForVolume, getSnapshotById, getScheduleById } from './snapshots';

// Utility for mock delay
export const mockDelay = (ms: number = 500): Promise<void> => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
